import ShoppingPage from './ShoppingPage';

export default ShoppingPage;
